import React, { Component } from "react";
import Select from "react-select";
import Button from "../../../button-classic/button-classic";
import "../../../route_code/route_code.less";
import Cx from "classnames";
import { setItemToSessionStorage } from "Utils/sessionStorage";
import InputText from '../../../../common/components/input-text/input-text';
import { material_type, vehicle_type } from "Utils/common";
import { debounce } from "Utils/index";


class AddPharmaTankerMaster extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {
        tank_no: this.props.editData ? this.props.editData.tank_no : "",
        material_desc: this.props.editData ? this.props.editData.material_desc : "",
        material: this.props.editData ? this.props.editData["material"] : "",
        material_id: this.props.editData ? this.props.editData["material_id"] : "",
        company_id: this.props.editData ? this.props.editData.company_id : this.props.companyId,
      },
    };
    this.debouncedGetInventoryItemData = debounce(this.props.getInventoryItem, 300);
  }

  

  componentDidMount() {
    setItemToSessionStorage("previousPharmaMaterialName", this.props.editData);
  }

  onChangeHandler = (value, id) => {
    let { data } = this.state;
    data[id] = value;
    this.setState({ data });
  };

  onChangeProductDetails = (e) => {
  let { data } = this.state;

  if (e) {
    data.material = e.value;
    if (this.props.editData) {
      data.material_id = this.props.editData.material_id;
    } else {
      data.material_id = e.productId;
    }
  } else {
    data.material = null;
    data.material_id = null;
  }

  this.setState({ data });
  };

  onSave = () => {
    const { data } = this.state;
    this.props.onSave(data);
  };

  onUpdate = () => {
    const { data } = this.state;
    this.props.onUpdate(data);
  };

  render() {
    const { data } = this.state;
    let optionProduct = [];

    if(this.props.productListData){
			for(let i = 0; i < this.props.productListData.length-1; i++) {
				optionProduct.push({
					value: this.props.productListData[i].product,
					label: this.props.productListData[i].materialName,
					productId: this.props.productListData[i].productMasterId
				});
			} 
		}

    const disable = !(
      data["tank_no"] &&
      data["material_desc"] &&
      data["material"]
    );

    return (
      <div className="route_code_detail">
        <div onClick={this.props.toggleAdd} className="overlay"></div>
        <div id="modal" className="modal-popup" style={{minHeight:"600px"}}>
          <div className="pop-heading">
            {`${this.props.editData ? "Edit" : "Add"} Pharma Tank Master`}
          </div>
          <div className="route-detail">
            <div
              className="details-section"
              style={{ display: "flex", gap: "100px" }}
            >
               <div style={{ display: "flex", flexDirection: "column" }}>
                <div className="label">
                  {"Material Name/Code"}
                  <span className="error-color">*</span>
                </div>
                <Select
                  className={Cx("selectpack")}
                  options={optionProduct}
                  value={optionProduct.find(prod => prod.value == data.material)}
                  onChange={(e) => this.onChangeProductDetails(e, 'material')}
                  isSearchable={true}
								  isClearable={true}
                  onInputChange={(value) => {
                  if (value.length > 3) {
                      this.debouncedGetInventoryItemData(value);
                  }
										return value
                  }}
                />
              </div>
              <div>
              <InputText
                placeholder=""
                id={"material_desc"}
                label="Material Description"
                changeHandler={(value) => this.onChangeHandler(value, "material_desc")}
                value={data["material_desc"]}
                required={true}
              />
               </div>
            </div>
            <div
              className="details-section"
              style={{ display: "flex", gap: "30px", marginTop: "20px" }}
            >
              <div>
              <InputText
                placeholder=""
                id={"tank_no"}
                label="Tank No"
                changeHandler={(value) => this.onChangeHandler(value, "tank_no")}
                value={data["tank_no"]}
                required={true}
              />
               </div>
            </div>

            <div className={"button_route"} style={{ marginTop: "50px" }}>
              <Button value={"Cancel"} click={this.props.toggleAdd} />
              {!this.props.editData ? (
                <Button 
                value={"Save"} 
                click={this.onSave}  
                disabled={disable}
                />
              ) : (
                <Button
                  value={"Update"}
                  click={this.onUpdate}
                  disabled={disable}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default AddPharmaTankerMaster;
